import React from "react";
import "../styles/FooterSimpleContenidoAds.scss";

const FooterSimpleContenidoAds = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="ovit-footerSimple" id="foot">
      <div className="ovit-footerSimple__container">
        <div className="ovit-footerSimple__brand">
          OVIT <span>Soluciones Web</span>
        </div>

        <div className="ovit-footerSimple__copy">
          © {year} Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
};

export default FooterSimpleContenidoAds;